var MdmLink = () => import('~/components/atoms/MdmLink.vue');
export default {
  name: 'Links',
  components: {
    MdmLink
  },
  props: {
    isScrambleLink: {
      type: Boolean,
      default: false
    },
    footerLinks: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};